import { Container, Loader } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import { useEffect, useRef, useState } from "react";
import { backendUrl } from "../../constants";
import PostJob from "../../EmployerPages/Dashboard/PostUpdate";
import MyPosts from "../../EmployerPages/Settings/MyPosts";
import Autoplay from "embla-carousel-autoplay";
import EmployerSlide from "../../components/EmployerSlide/employerCard";
import { Carousel } from "@mantine/carousel";

export const AllPosts = () => {
  let userData = JSON.parse(localStorage.getItem("userData"));
  const [update, setUpdate] = useState({ userId: userData.id, status: "" });
  const [topEmp, setTopEmp] = useState([]);
  const autoplay = useRef(Autoplay({ delay: 2000 }));

  //top employers
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}user/topEmployer`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = {
            key: obj._id,
            name: obj.companyProfileInfo?.[0]?.companyName,
            logo: obj.companyProfileInfo?.[0]?.companyLogo,
            tagLine: obj.companyProfileInfo?.[0].companyTagLine,
          };
          setTopEmp((topEmp) => [...topEmp, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //post news update
  const handleUpdate = () => {
    const options = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-type": "application/json",
      },
      body: JSON.stringify(update),
    };
    fetch(`${backendUrl}user/postStatusUpdate`, options)
      .then((response) => {
        setUpdate({ userId: userData.id, status: "" });
        showNotification({
          message: "Posted new update!",
          color: "green",
        });
      })
      .catch((err) => console.error(err));
  };
  return (
    <Container size="md">
      <div className="m-5">
        <PostJob
          handleUpdate={handleUpdate}
          setUpdate={setUpdate}
          update={update}
        />
      </div>
      <MyPosts />
      {topEmp.length > 0 ? (
        <>
          <h2 className="text-dark text-center mt-5 pb-4">Top Companies</h2>
          <Carousel
            align="center"
            plugins={[autoplay.current]}
            onMouseEnter={autoplay.current.stop}
            onMouseLeave={autoplay.current.reset}
            loop
            slideSize="20%"
            controlSize={40}
            // slideGap="md"
            slidesToScroll={1}
            height={"230px"}
            className="mb-4"
          >
            {topEmp &&
              topEmp.map((obj, key) => (
                <Carousel.Slide className="m-2" key={key}>
                  <EmployerSlide data={obj} key={obj.id} />
                </Carousel.Slide>
              ))}
          </Carousel>
        </>
      ) : (
        <Loader size="xl" className="text-center w-100 m-5" />
      )}
    </Container>
  );
};
